import { Context, Inject } from '@nuxt/types/app'
import { stripTrailingSlash } from '~/utils/string'

// import { Plugin } from '@nuxt/types'
type GenerateRouteFunc = (
  path?: Array<string> | string,
  includeRepoInPath?: boolean,
  teamPage?: boolean,
  provider?: string,
  owner?: string,
  repo?: string
) => string

declare module 'vue/types/vue' {
  interface Vue {
    $generateRoute: GenerateRouteFunc
  }
}

declare module '@nuxt/types' {
  interface NuxtAppOptions {
    $generateRoute: GenerateRouteFunc
  }
  interface Context {
    $generateRoute: GenerateRouteFunc
  }
}

declare module 'vuex/types/index' {
  // skipcq: JS-0387
  interface Store<S> {
    $generateRoute: GenerateRouteFunc
  }
}

export default (context: Context, inject: Inject): void => {
  const generateRoute: GenerateRouteFunc = (
    path?: Array<string> | string,
    includeRepoInPath = true,
    teamPage = false,
    provider = '',
    owner = '',
    repo = ''
  ) => {
    const baseRoute = ['']

    const { params } = context.route
    owner = owner || params.owner
    provider = provider || params.provider
    repo = repo || params.repo

    // Only include 'orgs' in route for team level pages
    if (teamPage) {
      baseRoute.push('orgs')
    }

    baseRoute.push(provider, owner)

    if (repo && includeRepoInPath) {
      baseRoute.push(repo)
    }

    if (path && Array.isArray(path)) {
      return stripTrailingSlash(baseRoute.concat(...path).join('/'))
    } else if (path) {
      path = stripTrailingSlash(path)
      return baseRoute.concat(path).join('/')
    }

    return baseRoute.join('/')
  }
  inject('generateRoute', generateRoute)
}
